/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { DocumentOcrDocumentStatusViewModel } from "../types/DocumentOcrDocumentStatusViewModel.ts";

export const documentOcrDocumentStatusViewModelSchema = z.object({
  status: z
    .string()
    .describe(
      'Veredito do documento: "aprovado", "aprovado_provisorio" ou "rejeitado". Opcional.',
    )
    .nullish(),
  rejectionReason: z
    .string()
    .describe(
      "Motivo exato da lista oficial de motivos de rejeição do sistema; nulo quando não rejeitado. Opcional.",
    )
    .nullish(),
  expirationDate: z
    .string()
    .describe(
      "Data de validade impressa no documento (dd/MM/yyyy); nula quando não há. Opcional.",
    )
    .nullish(),
  expired: z
    .boolean()
    .describe(
      "Indica se o documento está vencido; nulo quando não possui validade. Opcional.",
    )
    .nullish(),
}) as unknown as ToZod<DocumentOcrDocumentStatusViewModel>;
